export default function initServices() {
    if (typeof $().niceSelect === "undefined") {
        return false;
    }

    $(".custom-select select").niceSelect();
    registerFilterHandlers();
}

function registerFilterHandlers() {
    var form = $(".services-page .search-widget form");
    $("select", form).on("change", function () {
        form.submit();
    });
}
